import {BaseCriteriaModel} from '../base-criteria.model';
import {Option, Optional} from 'typescript-optional';

export class RateChargeQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_pgw_merchant_rate_hdr table
  guids?: Optional<string> = Optional.empty();
  contract_rate_guid?: Optional<string> = Optional.empty();
  payment_channel_guid?: Optional<string> = Optional.empty();
  rate_card_guid?: Optional<string> = Optional.empty();
  rate_card_line_guid? :Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  obj_type?: Optional<string> = Optional.empty();
  rate_logic?: Optional<string> = Optional.empty();
}

export class RateChargeCriteriaModelQuery {
  query = '';

  constructor(RateChargeCriteriaModel: RateChargeQueryCriteriaClass) {
    console.log('RateChargeCriteriaModel', RateChargeCriteriaModel);

    if (!RateChargeCriteriaModel) {
      return;
    }

    this.query += RateChargeCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');
    this.query += RateChargeCriteriaModel.contract_rate_guid.filter(x => x !== '').map(x => '&contract_rate_guid=' + x).orElse('');
    this.query += RateChargeCriteriaModel.payment_channel_guid.filter(x => x !== '').map(x => '&payment_channel_guid=' + x).orElse('');
    this.query += RateChargeCriteriaModel.rate_card_guid.filter(x => x !== '').map(x => '&rate_card_guid=' + x).orElse('');
    this.query += RateChargeCriteriaModel.rate_card_line_guid.filter(x => x !== '').map(x => '&rate_card_line_guid=' + x).orElse('');

    this.query += RateChargeCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += RateChargeCriteriaModel.obj_type.filter(x => x !== '').map(x => '&obj_type=' + x).orElse('');

    this.query += '&status=' + RateChargeCriteriaModel.status;
    this.query += '&orderBy=' + RateChargeCriteriaModel.orderBy;
    this.query += '&order=' + RateChargeCriteriaModel.order;
    this.query += '&offset=' + RateChargeCriteriaModel.offset + '&limit=' + RateChargeCriteriaModel.limit;
  }

}
